import type { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import type { AuditEntry } from "@/modules/audit/types";
import { amalNomi } from "@/modules/audit/utils/actions";
import { DataTable } from "@/shared/components/DataTable";
import { usePaginatedQuery } from "@/shared/hooks/usePaginatedQuery";

/**
 * «Audit izi» yorlig'i — shu xodim qatori ustidagi amallar.
 *
 * ⚠️⚠️ **`EmployeeListTab` karkasi ISHLATILMAYDI.** U so'rovga
 * `params: { employeeId }` qo'shadi, `AuditListQuerySchema` esa oddiy
 * `z.object` — zod noma'lum kalitni JIMGINA tashlab yuboradi. Natijada
 * yorliq BUTUN TIZIM auditini ko'rsatib, xodim doirasidan chiqib
 * ketardi va hech narsa yiqilmasdi. Shuning uchun `usePaginatedQuery`
 * to'g'ridan-to'g'ri, AYNAN `resourceType`/`resourceId` bilan
 * chaqiriladi.
 *
 * ⚠️⚠️ **Bu yorliq parol tiklashlarni KO'RMAYDI.** `POST
 * /users/{id}/reset-password` ning audit metadatasi `resource: "users"`
 * (`users.routes.ts`), ya'ni `resourceId` — `users.id`. Ikkinchi so'rov
 * QO'SHILMAYDI: ikki sahifalangan ro'yxatni birlashtirish sahifalash
 * mantiqini buzardi. O'rniga ostida bir qator izoh turadi.
 */
export function EmployeeAuditTab({ employeeId }: { employeeId: string }) {
	const { t } = useTranslation("employees");
	const query = usePaginatedQuery<AuditEntry>({
		queryKey: ["employees", "tab", "audit", employeeId],
		url: "/audit",
		params: { resourceType: "employees", resourceId: employeeId },
	});

	const columns: ColumnsType<AuditEntry> = [
		{
			title: t("auditTab.columns.at"),
			dataIndex: "at",
			key: "at",
			render: (value: string) => dayjs(value).format("YYYY-MM-DD HH:mm"),
		},
		{
			title: t("auditTab.columns.action"),
			dataIndex: "action",
			key: "action",
			render: (value: string) => amalNomi(value),
		},
		{
			title: t("auditTab.columns.actor"),
			key: "actor",
			// ⚠️ `actorName` `null` bo'lishi NORMAL — aktyorsiz yozuv
			// (`actor_user_id` `set null`) yoki xodim profili yo'q
			// foydalanuvchi.
			render: (_, row) => row.actorName ?? "—",
		},
		{
			title: t("auditTab.columns.reason"),
			dataIndex: "reason",
			key: "reason",
			render: (value: string | null) => value ?? "—",
		},
	];

	return (
		<>
			<DataTable<AuditEntry> columns={columns} query={query} />

			<div className="mt-3 text-xs text-[#8a929e]">{t("auditTab.note")}</div>
		</>
	);
}
